import axios from 'axios'

const StudentAuthService = {
  async signIn (params = {}) {
    return axios.post('student/login', params)
  },

  async getCurrentUser () {
    return axios.get('student/auth/me')
  },

  async changePassword (params = {}) {
    return axios.post('student/auth/password', params)
  },

  async sendPasswordChangeOtp () {
    return axios.post('student/auth/password-otp/send')
  },

  async verifyPasswordChangeOtp (otp) {
    return axios.post('student/auth/password-otp/verify', { otp })
  },

  async logout () {
    return axios.post('student/auth/logout')
  }
}

export default StudentAuthService
